import { Type } from '@hugendubel/ws_client';

export type OAuthAuthCodeWebResult = { code?: string };

const parse = (json: any): OAuthAuthCodeWebResult => ({
    code: Type.string(json.code, 'OAuthAuthCodeWebResult.code'),
});

export const WsOAuthAuthCodeWebResult = { parse };
